var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhaseChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 150,
    stroke: "black",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    fontSize: 20,
    textAnchor: "middle",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -168,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -175
  }, "270"), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 150,
    x2: 0,
    y2: 168,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 190
  }, "90"), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 0,
    x2: 168,
    y2: 0,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("text", {
    x: 175,
    y: 5
  }, "0"), /*#__PURE__*/React.createElement("line", {
    x1: -150,
    y1: 0,
    x2: -168,
    y2: 0,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("text", {
    x: -186,
    y: 5
  }, "180"), /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: -106,
    x2: 118,
    y2: -118,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: -128
  }, "315"), /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 106,
    x2: 118,
    y2: 118,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 128
  }, "45"), /*#__PURE__*/React.createElement("line", {
    x1: -106,
    y1: -106,
    x2: -120,
    y2: -120,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("text", {
    x: -128,
    y: -128
  }, "225"), /*#__PURE__*/React.createElement("line", {
    x1: -106,
    y1: 106,
    x2: -118,
    y2: 118,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("text", {
    x: -135,
    y: 135
  }, "135")), /*#__PURE__*/React.createElement("g", {
    stroke: "black"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -155
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(10)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(20)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(50)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(70)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(100)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(110)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(130)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(140)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(150)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(170)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(190)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(210)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(220)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(230)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(250)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(260)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(290)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(300)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(310)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(330)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(340)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(350)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -150,
    x2: 0,
    y2: -160
  }))), /*#__PURE__*/React.createElement("line", {
    x1: -100,
    y1: 0,
    x2: 100,
    y2: 0,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -100,
    x2: 0,
    y2: 100,
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhaseChart);
export default __webpack_public_path__ + "static/media/phase-chart.5b2021b5e7a3a7cb30e94155aee7a44c.svg";
export { ForwardRef as ReactComponent };